var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MdImg",style:([
  {
    aspectRatio: _vm.item.aspectRatio.replace(':', '/')
  },
  _vm.item.flex ? { flex: _vm.item.flex } : {}
])},[_c('span',{style:({backgroundImage: `url(${_vm.item.url})`, backgroundSize: _vm.item.aspectMode })})])
}
var staticRenderFns = []

export { render, staticRenderFns }